module.exports = __webpack_public_path__ + "static/media/trans-Offer-dispatch.4c7bebd0.svg";